const defaults = {
  name: 'Hello Molly',
  theme: 'hellomolly',
  logoSize: 'h-16',
  emails: {
    info: 'info@hellomolly.com',
    support: 'support@hellomolly.com',
    returns: 'returns@hellomolly.com',
  },
  addresses: {
    au: 'Hello Molly<br/>8 Hiles Street<br/>Alexandria<br/>NSW 2015<br/>Australia',
    us: 'Hello Molly<br/>8738 E 9th Street<br/>Rancho Cucamonga, CA 91730<br/>United States',
  },
  happyreturns: {
    retailer: 'hellomolly',
  },
  countries: ['au', 'us'],
}

const getLogoSizeForTheme = (theme) => {
  const logoSizes = {
    hellomolly: 'h-10',
    fortunateone: 'h-10',
    chicchaching: 'h-24',
  }
  return logoSizes[theme] || defaults.logoSize
}

const brand = {
  name: process.env.REACT_APP_BRAND_NAME || defaults.name,
  theme: process.env.REACT_APP_BRAND_THEME || defaults.theme,
  get logoSize() {
    return getLogoSizeForTheme(this.theme)
  },
  emails: {
    info: process.env.REACT_APP_BRAND_EMAIL_INFO || defaults.emails.info,
    support: process.env.REACT_APP_BRAND_EMAIL_SUPPORT || defaults.emails.support,
    returns: process.env.REACT_APP_BRAND_EMAIL_RETURNS || defaults.emails.returns,
  },
  addresses: {
    au: process.env.REACT_APP_BRAND_AU_ADDRESS || defaults.addresses.au,
    us: process.env.REACT_APP_BRAND_US_ADDRESS || defaults.addresses.us,
  },
  happyreturns: {
    retailer: process.env.REACT_APP_HAPPY_RETURN_RETAILER || defaults.happyreturns.retailer,
  },
  countries: process.env.REACT_APP_SUPPORTED_COUNTRIES
    ? process.env.REACT_APP_SUPPORTED_COUNTRIES.split(',')
    : defaults.countries,
  features: {
    linkOrdersEnabled: process.env.REACT_APP_FEATURE_LINK_ORDERS_ENABLED === 'true',
    externalPaymentEnabled: process.env.REACT_APP_FEATURE_EXTERNAL_PAYMENT_ENABLED === 'true',
  }
}

export default brand
